'use client'

import type { ReactNode } from 'react'

import { Anchor } from '@/components/client/seo/anchor'

interface NavMenuTriggerProps {
  href?: string
  open: boolean
  onToggle: () => void
  className?: string
  children: ReactNode
}

// The server-rendered href works before hydration or if JavaScript fails.
// Once interactive, ordinary activation opens the menu; modified clicks keep
// the browser's native navigation. Match button keyboard behavior for Space.
export const NavMenuTrigger = ({ href, open, onToggle, className, children }: NavMenuTriggerProps) => {
  if (!href) {
    return (
      <button type="button" data-tracking="ignore" aria-expanded={open} onClick={onToggle} className={className}>
        {children}
      </button>
    )
  }

  return (
    <Anchor
      href={href}
      role="button"
      data-tracking="ignore"
      aria-expanded={open}
      className={className}
      onClick={(event) => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
          return
        }
        event.preventDefault()
        onToggle()
      }}
      onKeyDown={(event) => {
        if (event.key === ' ') {
          event.preventDefault()
          if (!event.repeat) {
            onToggle()
          }
        }
      }}
    >
      {children}
    </Anchor>
  )
}
